import { StyleSheet, Text, View } from "react-native";

import {
  fonts,
  lightColors,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

import { Logomark } from "./Logomark";

export function BrandMark({
  tone = "default",
  size = "md",
}: {
  tone?: "default" | "inverse";
  size?: "sm" | "md" | "lg" | "xl";
}) {
  const { stylesheet, sizeStyles } = useThemedStyles(makeStyles);
  return (
    <View style={stylesheet.wrapper}>
      <Logomark size={iconSizes[size]} />
      <Text
        accessibilityRole="header"
        style={[
          stylesheet.mark,
          sizeStyles[size],
          tone === "inverse" ? stylesheet.inverse : null,
        ]}
      >
        mint<Text style={stylesheet.bold}>stint</Text>
      </Text>
    </View>
  );
}

const iconSizes = { sm: 18, md: 22, lg: 26, xl: 32 };

const makeStyles = (colors: ThemeColors) => {
  const stylesheet = StyleSheet.create({
    wrapper: { flexDirection: "row", alignItems: "center", gap: 8 },
    mark: {
      color: colors.heading,
      fontFamily: fonts.regular,
      letterSpacing: 0,
    },
    // Fixed light text for AuthScreen's permanently dark-green surface --
    // must not follow the theme, or dark mode flips it to near-black.
    inverse: { color: lightColors.background },
    bold: { fontFamily: fonts.bold },
    sm: { fontSize: 18 },
    md: { fontSize: 24 },
    lg: { fontSize: 28 },
    xl: { fontSize: 36 },
  });
  const sizeStyles = {
    sm: stylesheet.sm,
    md: stylesheet.md,
    lg: stylesheet.lg,
    xl: stylesheet.xl,
  };
  return { stylesheet, sizeStyles };
};
